// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68793ddb","732":"1b87418b","977":"1e9474f6"}[chunkId] + ".chunk.js";
};